module.exports = __webpack_public_path__ + "media/v3/assignment_placeholder_60-e5c59f92.png";